import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { getFeed } from "services/apiService";
import { useEffect } from "react";
import { useState } from "react";
import MDAvatar from "components/MDAvatar";
import { postUnLike } from "services/apiService";
import { postLike } from "services/apiService";
import { postComment } from "services/apiService";
import LikesDialog from "layouts/dialogModals/LikesDialog";
import CommentsDialog from "layouts/dialogModals/CommentDialog";
import InfiniteScroll from "react-infinite-scroll-component";
import { useMediaQuery } from "react-responsive";
import { getPostById } from "services/apiService";
import SpinLoader from "components/SpinLoader";
import { Grid, InputBase } from "@mui/material";
import { getAllVideos } from "services/apiService";
import ShareDialog from "layouts/dialogModals/ShareDialog";
import TelegramIcon from "@mui/icons-material/Telegram";

import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import ReelsLoader from "components/SkeletonLoader/reelsLoader";
import { loginDialogReducer } from "Store/slices/loginDialogSlice";
import { useDispatch, useSelector } from "react-redux";

export const Reels = () => {
  let navigate = useNavigate();
  let location = useLocation();

  const dispatch = useDispatch();

  const { userAuthInfo, loginStatus, isLoadingAuth } = useSelector(
    (state) => state.userAuth
  );

  // const [likeState, setLikeState] = useState(false);
  // const [commentState, setCommentState] = useState(false);
  const [campList, setCampList] = useState([]);
  const [post, setPost] = useState([]);
  const [comment, setComment] = useState("");
  const [postId, setPostId] = useState("");
  const [likeDialogBoolean, setLikeDialogBoolean] = useState(false);
  const [commentDialogBoolean, setCommentDialogBoolean] = useState(false);
  const [suggestionList, setSuggestionList] = useState([]);
  const [statusUpdateBoolean, setStatusUpdateBoolean] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [walletBalance, setWalletBalance] = useState("0");
  const [secondary, setSecondary] = React.useState(false);

  const [stop, setStop] = useState(false);
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isFetchMore, setIsFetchMore] = useState(false);
  const [commentCount, setCommentCount] = useState(0);
  const [shareDialogBoolean, setShareDialogBoolean] = useState(false);
  const [type, setType] = useState("");
  const [muted, setMuted] = useState(true);
  const [autoPlay, setAutoPlay] = useState(false);

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });

  useEffect(() => {
    fetchAllVideos();
  }, []);

  const fetchAllVideos = async () => {
    setLoading(true);
    const getAllVideosRes = await getAllVideos(pageNumber);
    // console.log("getAllVideosRes", getAllVideosRes);

    if (location.state != undefined || null) {
      setReels([location.state, ...getAllVideosRes]);
    } else {
      setReels(getAllVideosRes);
    }

    // setReels(getAllVideosRes);
    setLoading(false);
    if (getAllVideosRes.length > 1) {
      setIsFetchMore(true);
    }
    setPageNumber((prev) => prev + 1);
  };

  // console.log("reels", reels);

  const fetchMoreData = async () => {
    const getAllVideosResNew = await getAllVideos(pageNumber);
    if (getAllVideosResNew.length < 1) {
      setIsFetchMore(false);
      return;
    }
    // console.log("getAllVideosResNew", getAllVideosResNew);
    setReels(reels.concat(getAllVideosResNew));
    setPageNumber((prev) => prev + 1);
  };

  const handleUsernameClick = (username) => {
    navigate(`/profile/?username=${username}`);
  };

  const handleLikeUnLike = async (isLikedBoolean, postId) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    const postID = {
      postID: postId,
    };
    if (isLikedBoolean) {
      const postUnlikeRes = await postUnLike(postID);
      // console.log("postUnLikeRes", postUnlikeRes);

      const postByIdRes = await getPostById(postId);
      // console.log("postByid", postByIdRes);

      const replacePostById = (post, postByIdRes) => {
        return post.map((item) => {
          if (item._id === postByIdRes[0]._id) {
            return postByIdRes[0];
          }
          return item;
        });
      };

      const updatedReels = replacePostById(reels, postByIdRes);
      setReels(updatedReels);
    } else {
      const postLikeRes = await postLike(postID);
      // console.log("postLikeRes", postLikeRes);

      const postByIdRes = await getPostById(postId);
      // console.log("postByid", postByIdRes);

      const replacePostById = (post, postByIdRes) => {
        return post.map((item) => {
          if (item._id === postByIdRes[0]._id) {
            return postByIdRes[0];
          }
          return item;
        });
      };

      const updatedReels = replacePostById(reels, postByIdRes);
      setReels(updatedReels);
    }
  };

  const openLikesDialog = (value) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(value);
    setLikeDialogBoolean(true);
  };

  const handleCloseLikeDialog = () => {
    setLikeDialogBoolean(false);
  };

  const openCommentsDialog = (id, count) => {
    if (!loginStatus) {
      dispatch(loginDialogReducer(true));
      return;
    }

    setPostId(id);
    setCommentCount(count);
    setCommentDialogBoolean(true);
  };

  const handleCloseCommentDialog = async () => {
    const postByIdRes = await getPostById(postId);
    // console.log("postByid", postByIdRes);

    const replacePostById = (post, postByIdRes) => {
      return post.map((item) => {
        if (item._id === postByIdRes[0]._id) {
          return postByIdRes[0];
        }
        return item;
      });
    };

    const updatedReels = replacePostById(reels, postByIdRes);
    setReels(updatedReels);

    setCommentDialogBoolean(false);
  };

  useEffect(() => {
    videoScroll();
    window.addEventListener("scroll", videoScroll);
    return () => {
      window.removeEventListener("scroll", videoScroll);
    };
  }, []);

  const videoScroll = () => {
    if (document.querySelectorAll("video").length > 0) {
      var windowHeight = window.innerHeight,
        videoEl = document.querySelectorAll("video");

      var mostCenteredVideoEl;
      var mostCenteredVideoDistance = Number.MAX_SAFE_INTEGER;

      for (let i = 0; i < videoEl.length; i++) {
        var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
        var videoCenter = Math.abs(
          windowHeight / 2 - (videoClientRect + videoHeight / 2)
        );

        if (videoCenter < mostCenteredVideoDistance) {
          mostCenteredVideoDistance = videoCenter;
          mostCenteredVideoEl = thisVideoEl;
        }
      }

      // for (let i = 0; i < videoEl.length; i++) {
      //   if (videoEl[i] === mostCenteredVideoEl) {
      //     videoEl[i].play();
      //   } else {
      //     videoEl[i].pause();
      //   }
      // }
      for (let i = 0; i < videoEl.length; i++) {
        if (videoEl[i] === mostCenteredVideoEl) {
          if (videoEl[i].paused) {
            videoEl[i].play();
          }
        } else {
          if (!videoEl[i].paused) {
            videoEl[i].pause();
          }
        }
      }
    }
  };

  const handleShare = (type, postId) => {
    setType(type);
    setPostId(postId);
    setShareDialogBoolean(true);
  };

  const handleCloseShareDialog = () => {
    setShareDialogBoolean(false);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <Grid
          container
          sx={{
            justifyContent: "center",
          }}
        >
          <Grid item xs={12} md={5} lg={5}>
            <InfiniteScroll
              style={{
                position: "relative",
                scrollSnapType: "y mandatory",
              }}
              dataLength={reels.length}
              next={fetchMoreData}
              hasMore={isFetchMore}
              loader={
                <MDBox sx={{ textAlign: "center" }}>
                  <SpinLoader />
                </MDBox>
              }
            >
              {loading ? (
                <ReelsLoader />
              ) : reels.length > 0 ? (
                reels.map((item, idx) => (
                  <MDBox
                    mb={3}
                    key={idx}
                    sx={{
                      borderRadius: "25px",
                      scrollSnapAlign: "start",
                      scrollSnapStop: "normal",
                    }}
                  >
                    <Card sx={{ borderRadius: "25px" }}>
                      <MDBox
                        sx={{
                          position: "relative",
                          height: "600px",
                          borderRadius: "25px",
                        }}
                      >
                        <IconButton
                          sx={{
                            color: "#fff",
                            position: "absolute",
                            top: 10,
                            right: 10,
                          }}
                        >
                          {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                        </IconButton>
                        <MDBox
                          sx={{
                            position: "absolute",
                            bottom: 10,
                            zIndex: 1,
                            cursor: "pointer",
                          }}
                        >
                          <CardHeader
                            sx={{
                              padding: "10px",
                            }}
                            avatar={
                              <MDAvatar
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUsernameClick(item.username)
                                }
                                src={item.pic}
                                imgProps={{
                                  style: { height: "100%", width: "100%" },
                                }}
                              />
                            }
                            title={
                              <MDTypography
                                fontWeight="bold"
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleUsernameClick(item.username)
                                }
                              >
                                {item.username}
                              </MDTypography>
                            }
                          />
                        </MDBox>
                        <video
                          style={{
                            height: "100%",
                            width: "100%",
                            objectFit: "cover",
                            borderRadius: "25px",
                          }}
                          onVolumeChange={(event) => {
                            if (event.target.muted) {
                              setMuted(true);
                            } else {
                              setMuted(false);
                            }
                          }}
                          onPlaying={() => setAutoPlay(true)}
                          onPause={() => setAutoPlay(false)}
                          onClick={() => setMuted((prev) => !prev)}
                          muted={muted}
                          loop
                          src={item.photo}
                          poster={item.thumbnail}
                          playsInline
                        ></video>
                        <MDBox
                          sx={{
                            position: "absolute",
                            right: 0,
                            bottom: 80,
                          }}
                        >
                          <CardActions disableSpacing>
                            <MDBox
                              sx={{
                                display: "flex",
                                flexDirection: "column",

                                alignItems: "center",
                              }}
                            >
                              <IconButton
                                aria-label="add to favorites"
                                onClick={() =>
                                  handleLikeUnLike(item.isLiked, item._id)
                                }
                              >
                                {item.isLiked ? (
                                  <FavoriteIcon style={{ color: "red" }} />
                                ) : (
                                  <FavoriteBorderIcon
                                    style={{ color: "#fff" }}
                                  />
                                )}
                              </IconButton>
                              <MDTypography
                                fontWeight="bold"
                                sx={{ cursor: "pointer" }}
                                onClick={() => openLikesDialog(item._id)}
                              >
                                {item.totalLike}
                              </MDTypography>

                              <IconButton
                                onClick={() =>
                                  openCommentsDialog(
                                    item._id,
                                    item.totalComment
                                  )
                                }
                              >
                                <ChatBubbleOutlineIcon
                                  style={{ color: "#fff" }}
                                />
                              </IconButton>
                              <MDTypography
                                fontWeight="bold"
                                sx={{ cursor: "pointer" }}
                                onClick={() =>
                                  openCommentsDialog(
                                    item._id,
                                    item.totalComment
                                  )
                                }
                              >
                                {item.totalComment}
                              </MDTypography>
                              <IconButton
                                onClick={() => handleShare("post", item._id)}
                              >
                                <TelegramIcon style={{ color: "#fff" }} />
                              </IconButton>
                            </MDBox>
                          </CardActions>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                ))
              ) : (
                <MDBox sx={{ textAlign: "center" }}>
                  <MDTypography>No reels found</MDTypography>
                </MDBox>
              )}
            </InfiniteScroll>
          </Grid>
        </Grid>
      </MDBox>

      {shareDialogBoolean && (
        <ShareDialog
          openStatus={shareDialogBoolean}
          onClose={() => handleCloseShareDialog()}
          postId={postId}
          type={type}
        />
      )}

      {likeDialogBoolean && (
        <LikesDialog
          openStatus={likeDialogBoolean}
          onClose={() => handleCloseLikeDialog()}
          postId={postId}
        />
      )}
      {commentDialogBoolean && (
        <CommentsDialog
          openStatus={commentDialogBoolean}
          onClose={() => handleCloseCommentDialog()}
          postId={postId}
          commentCount={commentCount}
        />
      )}
    </DashboardLayout>
  );
};
